@if (objectType === 'Opportunity') {
  <div class="pipeline-dropdown">
    <glxy-form-field class="form-field" [showLabel]="false" [bottomSpacing]="'none'">
      <glxy-label>{{ 'OPPORTUNITY.PIPELINE.SELECTOR.TITLE' | translate }}</glxy-label>
      <mat-select [formControl]="selectedPipelineControl" [compareWith]="comparePipelines">
        @let pipelines = allPipelines$ | async;
        @if (pipelines && pipelines.length > 0) {
          @for (pipeline of pipelines; track pipeline) {
            <mat-option [value]="pipeline">{{ pipeline.name }}</mat-option>
          }
        } @else {
          <mat-option [value]="this.noPipelinesOption" disabled>{{
            'OPPORTUNITY.PIPELINE.SELECTOR.NO_PIPELINES' | translate
          }}</mat-option>
        }
        <mat-divider></mat-divider>
        <mat-option (click)="openPipelineSettings()">
          <span class="manage-pipelines">{{ 'PIPELINES.SETTINGS.TITLE' | translate }}</span>
        </mat-option>
      </mat-select>
    </glxy-form-field>
  </div>
}
